import { useEffect,  useRef, useState } from "react";
import { EmojiProvider, Emoji } from "react-apple-emojis"
import emojiData from "react-apple-emojis/src/data.json"
import { motion,  useScroll, useSpring, useTransform } from "framer-motion"
import { Link } from "react-router-dom";

function useParallax(value, distance){
    return useTransform(value, [0,1], [-distance, distance]);
}

export default function ProjectCard({
    project,
    boxSize,
    textSize = 16,
    bgTextSize = 75
}) {


    /**----------------------
     *    for parallax effect
     *------------------------**/
    const ref = useRef(null);


    // const { scrollY } = useScroll();
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ['start end', 'end start'],
        layoutEffect: false,
    });

    const thumbnailY = useParallax(scrollYProgress, 40);
    const textY = useParallax(scrollYProgress, -30);

    const springConfig = { stiffness: 1000, damping: 100, restDelta: 0.001 };
    const thumbnailYSpring = useSpring(thumbnailY, springConfig);
    const textYSpring = useSpring(textY, springConfig);

    /*---- END OF parallax effect ----*/
    
    
    
    
    /**----------------------
     *    ensure project is passed
     *------------------------**/

    const [ready, setReady] = useState(false);

    useEffect(() => {
        if(!project){
            throw new Error("Please pass project into ProjectCard");
        }
        else{
            setReady(true);
        }

    }, [project]);
    /*---- END OF SECTION ----*/
    
    





    if(ready){
        return (
            <Link
                to="/ProjectDetails"
                state={{selectedProject: project}}
                className="
                    group
                "
            >
                <div
                    className="
                        relative
                        overflow-hidden
                    "


                    style={{
                        height: boxSize,
                        width: boxSize,
                        backgroundImage: `linear-gradient(to bottom, ${project.gradient[0]}, ${project.gradient[1]})`,
                    }}
                >

                    <motion.div
                        className="
                            absolute
                            w-full
                            h-full
                            flex
                            justify-center
                            items-center



                        "
                        style={{
                            fontSize: bgTextSize,
                            translateY: textYSpring
                        }}
                    >
                        <span
                            className="
                                font-black
                                tracking-widest
                                italic
                                text-nowrap

                                transition-transform
                                duration-300
                                ease-in-out
                                group-hover:scale-110

                            "
                            style={{
                                color: project.bgTextColour
                            }}
                        >
                            {
                                project.title.toUpperCase()
                            }
                        </span>
                    </motion.div>



                    <div
                        ref={ref}
                        className="
                            h-full
                            w-full
                            flex
                            justify-center
                            items-center

                            transition-transform
                            duration-300
                            ease-in-out
                            group-hover:scale-90
                        "
                    >
                        <motion.div
                            className="
                                h-5/6
                                w-5/6

                                absolute
                            "
                                // inset-1/4
                                // -translate-y-1/2
                                // -translate-x-1/2
                            style={{
                                translateY: thumbnailYSpring,
                                // scale: thumbnailYSpring,
                                // translateX: "-50%"
                            }}
                        >
                            <img
                                src={project.thumbnail}
                                alt={project.thumbnailAlt}
                                className="
                                    object-contain
                                    object-center
                                    h-full
                                    w-full
                                "
                            />
                        </motion.div>

                    </div>


                </div>

                <div
                    className="
                        mt-2
                        flex
                        justify-between
                    "
                >
                    <span
                        className="
                            flex
                            items-center

                            font-semibold
                            text-body-text-light
                            dark:text-body-text-dark
                        "

                        style={{
                            fontSize: textSize
                        }}
                    >
                        <EmojiProvider data={emojiData}>
                            <Emoji className="inline" name={project.emoji} width={textSize}/>
                        </EmojiProvider>
                        &nbsp;
                        {
                            project.title.toUpperCase()
                        }
                    </span>

                    <span
                        className="
                            font-semibold
                            text-body-text-grey
                        "
                        style={{
                            fontSize: textSize
                        }}
                    >
                        {
                            project.type.toUpperCase()
                        }
                    </span>

                </div>
            </Link>
        );
    }

}